module.exports = __webpack_public_path__ + "static/media/Img_3.ba208cf8.jpg";